<template>
  <div>
    <TeJobAndroidCover />

    <TeJobAbout>
      <template #title>
        Androidアプリ
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          Javaを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-ota.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Kazuki Ota"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Kazuki Ota
          </h4>
          <p>
            システムエンジニア歴約20年、プログラミング歴約35年。プログラミングの守備範囲は、フロントエンド、サーバサイド、Android開発と広く、また、普段はシステム開発プロジェクトの管理や後輩の指導を行っています。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-hori.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Kazuumi Hori"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Kazuumi Hori
          </h4>
          <p>
            アプリはAndroid/iOSと、WebフロントエンドからバックエンドのAPIまでフルスタックに開発を行っています。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          Androidアプリメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-java.png"
                alt="Java"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Java
            </template>
            <template #description>
              Javaの基礎知識、業務での開発経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-androidstudio.png"
                alt="Android Studio"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Android Studio
            </template>
            <template #description>
              Android Studioの基礎知識とAndroidアプリ開発の実務経験（1年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-github.png"
                alt="Git/GitHub"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Git/GitHub
            </template>
            <template #description>
              Gitの基礎知識とGitHub上でのソースコード管理経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-firebase.png"
                alt="Firebase"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Firebase
            </template>
            <template #description>
              バックエンドサービスFirebaseの把握
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="android" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobAndroidCover from '~/components/Te/TeJob/Android/TeJobAndroidCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

useJobHead()

useHead({
  title: 'Androidアプリ講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするAndroidアプリメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'Androidアプリ講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするAndroidアプリメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-android.jpg',
      ogTitle: 'Androidアプリ講師（メンター）募集',
      ogDescription:
        '受講生をサポートするAndroidアプリメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/android',
      ogImage: '/_nuxt/ogp/og-image-mentor-android.jpg',
    }),
  ],
})
</script>
